import * as React from 'react';
import NavBar from './NavBar';
import Container from './Container';
import SideBar from './Sidebar/SideBar';

export default class Landing extends React.Component {
  render() {
    return (
      <div className="App" id="main-wrapper">
        <NavBar history={this.props.history} />
        <SideBar history={this.props.history} />
        <Container />
      </div>
    );
  }
}